import React from "react";
import _ from "lodash";
import cx from "classnames";
import { Field } from "redux-form";
import Utils from "../../../helpers/Utils";
import SwitcherInformer from "../../widgets/SwitchInformer";
import { ReduxTripleSwitch } from "../../widgets/redux/ReduxTripleSwitch";
import PatientMedicalAlertSubCategories from "./PatientMedicalAlertSubCategories";
import ReduxMedicalAlertNameSwitch from "../../widgets/redux/ReduxMedicalAlertNameSwitch";

export const PatientMedicalAlertsElement = (props) => {
  const { editMode, element, values, index } = props;
  let switchElement;
  let noteElement;

  if (editMode) {
    switchElement = ElementTypeBasedSwitcher(props, "edit");
    noteElement = <PatientMedicalAlertSubCategories element={element} values={values} />;
  } else {
    switchElement = ElementTypeBasedSwitcher(props, "view");
    noteElement = <span>{Utils.getNoteText(element)}</span>;
  }

  return (
    <div
      key={index}
      className="alerts-row mb-2"
      style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.3)" }}
    >
      {ElementTypeBasedSwitcher(props, "list")}

      <div className="medical-alerts-box switch-box">{switchElement}</div>
      <div className="medical-alerts-box box-description" style={{ overflowX: "unset" }}>
        {noteElement}
      </div>
    </div>
  );
};

export default PatientMedicalAlertsElement;

const SelectedInformer = ({ selected, title }) => {
  return (
    <button
      type="button"
      className={cx("btn btn-sm btn-default", {
        "btn-primary": _.isBoolean(selected) && selected,
      })}
    >
      {title}
    </button>
  );
};

const ElementTypeBasedSwitcher = (props, mode) => {
  const { element, values, index } = props;

  if (!element) return null;
  const indexedTitle = `${index + 1}. ${element.title}`;
  const isDiseaseAllergy = element?.type === "_DISEASE_ALLERGY";

  if (mode === "edit") {
    return (
      <Field
        defaultChecked={element.switchState}
        checked={values?.[`switch${index}`]}
        component={isDiseaseAllergy ? ReduxTripleSwitch : ReduxMedicalAlertNameSwitch}
        name={element.switchName}
        title={indexedTitle}
      />
    );
  }

  if (mode === "view") {
    return isDiseaseAllergy ? (
      <SwitcherInformer state={element.switchState} />
    ) : (
      <SelectedInformer selected={element.switchState} title={indexedTitle} />
    );
  }

  if (mode === "list" && isDiseaseAllergy) {
    return (
      <div className="medical-alerts-box box-label">
        <span>{`${index + 1}. ${element.title}`}</span>
      </div>
    );
  }
  return null;
};
